import { render, staticRenderFns } from "./RegionSwitcher.vue?vue&type=template&id=27d00f94&scoped=true&"
import script from "./RegionSwitcher.vue?vue&type=script&lang=ts&"
export * from "./RegionSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./RegionSwitcher.vue?vue&type=style&index=0&id=27d00f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d00f94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d00f94')) {
      api.createRecord('27d00f94', component.options)
    } else {
      api.reload('27d00f94', component.options)
    }
    module.hot.accept("./RegionSwitcher.vue?vue&type=template&id=27d00f94&scoped=true&", function () {
      api.rerender('27d00f94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/footer/RegionSwitcher.vue"
export default component.exports